import { t } from '../../../lib/i18n';
import { type AuctionScheduleItem } from '../types';
import {
  UKRAINE_TIMEZONE,
  formatCurrency,
  getBidManagementUrl,
  getEffectiveEndDate,
} from '../utils';

const TIME_FMT = new Intl.DateTimeFormat('uk-UA', {
  timeZone: UKRAINE_TIMEZONE,
  hour: '2-digit',
  minute: '2-digit',
});

/** One closing under the selected calendar day, in Design D tokens. */
export function CalendarDayCard({ auction }: { auction: AuctionScheduleItem }) {
  const end = getEffectiveEndDate(auction.end_date);
  const timeText = Number.isNaN(end.getTime())
    ? t('auctionSchedule.board.none')
    : TIME_FMT.format(new Date(auction.end_date));
  const bidCount = auction.bidCount ?? 0;

  return (
    <a
      href={getBidManagementUrl(auction)}
      className="flex items-center gap-2.5 rounded-cf-lg border border-cf-line bg-cf-surface px-3.5 py-3 hover:border-cf-ink"
    >
      <span className="w-11 shrink-0 font-mono text-[13px] text-cf-ink-subtle">{timeText}</span>
      <div className="min-w-0 flex-1">
        <div className="truncate text-[13px] font-semibold">{auction.car_name}</div>
        <div className="truncate text-xs text-cf-ink-subtle">
          {auction.listing_id}
          {auction.highestBidAmount ? ` · ${formatCurrency(auction.highestBidAmount)}` : ''}
        </div>
      </div>
      <span
        className={`shrink-0 font-mono text-[13px] ${bidCount > 0 ? 'text-cf-ok' : 'text-cf-ink-subtle'}`}
      >
        {bidCount > 0 ? bidCount : t('auctionSchedule.board.none')}
      </span>
    </a>
  );
}
